/* eslint-disable import/no-named-default */
import { documentTypes as customPdfDocumentTypes } from './sdgrouphub/template/pdf'

export const customPdfConfigs = customPdfDocumentTypes // {} customPdfDocumentTypes